import {
  ActivityTemplateDetailPageData,
  ActivityTemplateEditableFields,
  ActivityTemplateImageUploadFields,
  ActivityTemplatesPageData,
  ActivityTypesPageData,
  ActivityRegistryPageData,
  AdminClientsPageData,
  CaseloadEngagementPageData,
  CaseloadEngagementPeriod,
  HomeworkOverviewPeriod,
  HomeworkOverviewReportData,
  CompletionByDevicePeriod,
  CompletionByDeviceReportData,
  DashboardAttentionReportData,
  ClinicsPageData,
  ClientRankLevelRulesData,
  ClientCopingSkillsData,
  ClientValuesData,
  ValueEngagementReportData,
  ClientProfilePageData,
  ClientAccessScope,
  ClientMutationFields,
  AdminTherapistRole,
  CreateClinicData,
  UpdateClinicData,
  UpdateClinicFields,
  CreateClientData,
  CreateClientFields,
  CreateClientValueData,
  CreateClientRankLevelRuleData,
  CreateClientRankLevelRuleFields,
  CopingSkillsData,
  CreateCopingSkillData,
  CreateCopingSkillFields,
  CreateClientCopingSkillData,
  CreateActivityTemplateData,
  CreateLovOptionData,
  CreateLovOptionFields,
  CreateTherapistData,
  UpdateTherapistData,
  UpdateTherapistFields,
  CreateHomeworkData,
  CreateHomeworkActivityData,
  CreateHomeworkActivityFields,
  ClinicianAssistantContext,
  ClinicianAssistantHistoryMessage,
  ClinicianAssistantResult,
  ClinicianAssistantScope,
  ClinicianPortalApiEnvelope,
  ClinicianPortalApiRequest,
  CurrentHomeworkPageData,
  DailyMoodChecksPageData,
  YouthTopProblemRatingsPageData,
  ExpectanciesPageData,
  DeleteHomeworkData,
  DuplicateHomeworkData,
  GenerateHomeworkAnalysisData,
  HomeworkAnalysesPageData,
  HomeworkHistoryFilter,
  HomeworkHistoryPageData,
  ClientSessionsPageData,
  ClientSessionTranscriptData,
  ClientSessionFilter,
  clientSessionFilters,
  HomeworkCalendarPageData,
  HomeworkActivitiesPageData,
  HomeworkDetailPageData,
  HomeworkUpdateFields,
  HomeworkStepsUpdateFields,
  LovCatalogsPageData,
  LovOptionsPageData,
  MyClientsPageData,
  SupervisorTeamClientsData,
  SupervisorTeamClientDetailData,
  SupervisorTeamHomeworkData,
  SupervisorTeamHomeworkDetailData,
  SupervisorTeamReportsData,
  SupervisorTeamOverviewData,
  SupervisorTeamAttentionData,
  RecordFormConfigData,
  RelationOptionsData,
  RankLevelsData,
  PortalOperation,
  PortalTableKey,
  TablePreferencesData,
  SelectHomeworkTemplateData,
  SetClientValueEnabledData,
  SetClientRankLevelRuleEnabledData,
  SetCopingSkillEnabledData,
  SetClientCopingSkillEnabledData,
  SetLovOptionEnabledData,
  TherapistsPageData,
  UpdateActivityTemplateData,
  UpdateActivityTemplateStepsData,
  UploadActivityTemplateImageData,
  DeleteActivityTemplateImageData,
  HomeworkImageUploadFields,
  UploadHomeworkImageData,
  DeleteHomeworkImageData,
  UpdateHomeworkData,
  UpdateHomeworkStepsData,
  UpdateClientData,
  UpdateClientFields,
  UpdateClientValueData,
  UpdateClientRankLevelRuleData,
  UpdateClientRankLevelRuleFields,
  UpdateCopingSkillData,
  UpdateCopingSkillFields,
  UpdateClientCopingSkillData,
  UpdateLovOptionData,
  UpdateLovOptionFields,
  homeworkHistoryFilters,
  caseloadEngagementPeriods,
  homeworkOverviewPeriods,
  completionByDevicePeriods,
} from "./contracts";
import {
  parseCreateHomeworkEnvelope,
  parseCreateHomeworkActivityEnvelope,
  parseCreateActivityTemplateEnvelope,
  parseCreateClinicEnvelope,
  parseUpdateClinicEnvelope,
  parseCreateClientEnvelope,
  parseCreateClientValueEnvelope,
  parseCreateClientRankLevelRuleEnvelope,
  parseCreateCopingSkillEnvelope,
  parseCreateClientCopingSkillEnvelope,
  parseCreateLovOptionEnvelope,
  parseCreateTherapistEnvelope,
  parseAskClinicianAssistantEnvelope,
  parseUpdateTherapistEnvelope,
  parseDeleteHomeworkEnvelope,
  parseDuplicateHomeworkEnvelope,
  parseGetClientEnvelope,
  parseGetClientValuesEnvelope,
  parseGetValueEngagementEnvelope,
  parseGetHomeworkOverviewEnvelope,
  parseGetCompletionByDeviceEnvelope,
  parseGetDashboardAttentionEnvelope,
  parseGetSupervisorTeamAttentionEnvelope,
  parseGetClientRankLevelRulesEnvelope,
  parseGetRankLevelsEnvelope,
  parseGetCopingSkillsEnvelope,
  parseGetClientCopingSkillsEnvelope,
  parseGetRecordFormConfigEnvelope,
  parseGetRelationOptionsEnvelope,
  parseGetActivityTemplateEnvelope,
  parseGetActivityTemplatesEnvelope,
  parseGetActivityTypesEnvelope,
  parseGetActivityRegistryEnvelope,
  parseGetAllClientsEnvelope,
  parseGetClinicsEnvelope,
  parseGetCurrentHomeworkEnvelope,
  parseGetDailyMoodChecksEnvelope,
  parseGetYouthTopProblemRatingsEnvelope,
  parseGetExpectanciesEnvelope,
  parseGetHomeworkActivitiesEnvelope,
  parseGetHomeworkDetailEnvelope,
  parseGetHomeworkHistoryEnvelope,
  parseGetClientSessionsEnvelope,
  parseGetClientSessionTranscriptEnvelope,
  parseGetHomeworkCalendarEnvelope,
  parseGetCaseloadEngagementEnvelope,
  parseGetHomeworkAnalysesEnvelope,
  parseGetLovCatalogsEnvelope,
  parseGetLovOptionsEnvelope,
  parseGetMyClientsEnvelope,
  parseGetTablePreferencesEnvelope,
  parseSaveTablePreferencesEnvelope,
  parseGetSupervisorTeamClientsEnvelope,
  parseGetSupervisorTeamClientDetailEnvelope,
  parseGetSupervisorTeamHomeworkEnvelope,
  parseGetSupervisorTeamHomeworkDetailEnvelope,
  parseGetSupervisorTeamReportsEnvelope,
  parseGetSupervisorTeamOverviewEnvelope,
  parseGetTherapistsEnvelope,
  parseGenerateHomeworkAnalysisEnvelope,
  parseSelectHomeworkTemplateEnvelope,
  parseSetClientValueEnabledEnvelope,
  parseSetClientRankLevelRuleEnabledEnvelope,
  parseSetCopingSkillEnabledEnvelope,
  parseSetClientCopingSkillEnabledEnvelope,
  parseSetLovOptionEnabledEnvelope,
  parseUpdateActivityTemplateEnvelope,
  parseUpdateActivityTemplateStepsEnvelope,
  parseUploadActivityTemplateImageEnvelope,
  parseDeleteActivityTemplateImageEnvelope,
  parseUploadHomeworkImageEnvelope,
  parseDeleteHomeworkImageEnvelope,
  parseUpdateHomeworkEnvelope,
  parseUpdateHomeworkStepsEnvelope,
  parseUpdateClientEnvelope,
  parseUpdateClientValueEnvelope,
  parseUpdateClientRankLevelRuleEnvelope,
  parseUpdateCopingSkillEnvelope,
  parseUpdateClientCopingSkillEnvelope,
  parseUpdateLovOptionEnvelope,
} from "./validators";
import {
  clinicianPortalRequestCache,
  PortalRequestCache,
} from "./portalRequestCache";

export class ClinicianPortalApiError extends Error {
  constructor(
    message: string,
    public readonly code:
      | "NOT_CONFIGURED"
      | "NETWORK_ERROR"
      | "INVALID_RESPONSE"
      | "INVALID_REQUEST"
      | "INVALID_CLIENT_CREATE_REQUEST"
      | "INVALID_CLIENT_UPDATE_REQUEST"
      | "REQUIRED_FIELD_MISSING"
      | "INVALID_LOV_VALUE"
      | "DISABLED_LOV_VALUE"
      | "INVALID_FIELD_TYPE"
      | "INVALID_INTEGER"
      | "VALUE_BELOW_MINIMUM"
      | "VALUE_ABOVE_MAXIMUM"
      | "INVALID_HIGH_SUDS_THRESHOLD"
      | "INVALID_POINTS"
      | "INVALID_COINS"
      | "NO_CLIENT_FIELDS_PROVIDED"
      | "FIELD_NOT_EDITABLE"
      | "CLINIC_NOT_AVAILABLE"
      | "INVALID_NICKNAME"
      | "INVALID_STATUS"
      | "INVALID_SUDS_INPUT_STYLE"
      | "INVALID_COPING_STRATEGIES"
      | "INVALID_FUN_ACTIVITIES"
      | "INVALID_PATIENT_UPDATE"
      | "INVALID_DATA_REQUEST"
      | "INVALID_RANK_LEVEL_ID"
      | "RANK_LEVEL_NOT_FOUND"
      | "RANK_LEVEL_DISABLED"
      | "INVALID_THRESHOLD_POINTS"
      | "NO_RANK_LEVEL_RULE_FIELDS_PROVIDED"
      | "DUPLICATE_CLIENT_RANK_LEVEL_RULE"
      | "INVALID_COPING_SKILL_ID"
      | "COPING_SKILL_NOT_FOUND"
      | "INVALID_COPING_STRATEGY_OPTION_ID"
      | "COPING_STRATEGY_OPTION_NOT_FOUND"
      | "COPING_STRATEGY_OPTION_DISABLED"
      | "INVALID_GUIDE_STEPS"
      | "NO_COPING_SKILL_FIELDS_PROVIDED"
      | "DUPLICATE_COPING_SKILL"
      | "DUPLICATE_CLIENT_COPING_SKILL"
      | "DUPLICATE_LOV_OPTION"
      | "DUPLICATE_CLINIC"
      | "INVALID_CLINIC_NAME"
      | "THERAPIST_REQUIRED"
      | "THERAPIST_NOT_FOUND"
      | "DUPLICATE_THERAPIST"
      | "INVALID_THERAPIST_NAME"
      | "INVALID_EMAIL"
      | "INVALID_ROLE"
      | "CLINIC_NOT_FOUND"
      | "ADMIN_REQUIRED"
      | "FORBIDDEN"
      | "NOT_AUTHORIZED"
      | "NOT_FOUND"
      | "TIMEOUT"
      | "UPSTREAM_ERROR",
    public readonly retryable: boolean,
  ) {
    super(message);
    this.name = "ClinicianPortalApiError";
  }
}

type FetchImplementation = typeof fetch;

export interface ClinicianPortalApiOptions {
  endpoint?: string;
  fetchImpl?: FetchImplementation;
  requestCache?: PortalRequestCache;
}

export interface ClinicianAssistantRequestOptions {
  scope: ClinicianAssistantScope;
  requestingTherapistId?: string;
  signal?: AbortSignal;
}

export interface ClinicianPortalApi {
  askClinicianAssistant(
    clinicianCode: string,
    question: string,
    context: ClinicianAssistantContext,
    history: ClinicianAssistantHistoryMessage[],
    options: ClinicianAssistantRequestOptions,
  ): Promise<ClinicianAssistantResult>;
  getMyClients(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<MyClientsPageData>;
  getTablePreferences(
    clinicianCode: string,
    tableKey: PortalTableKey,
    signal?: AbortSignal,
  ): Promise<TablePreferencesData>;
  saveTablePreferences(
    clinicianCode: string,
    tableKey: PortalTableKey,
    columnOrder: string[],
    hiddenColumns: string[],
    columnWidths: Record<string, number>,
    schemaVersion: number,
    signal?: AbortSignal,
  ): Promise<TablePreferencesData>;
  getSupervisorTeamOverview(
    clinicianCode: string,
    clinicId?: string,
    signal?: AbortSignal,
  ): Promise<SupervisorTeamOverviewData>;
  getSupervisorTeamClients(
    clinicianCode: string,
    clinicId?: string,
    signal?: AbortSignal,
  ): Promise<SupervisorTeamClientsData>;
  getSupervisorTeamClientDetail(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
  ): Promise<SupervisorTeamClientDetailData>;
  getSupervisorTeamHomework(
    clinicianCode: string,
    clinicId?: string,
    signal?: AbortSignal,
  ): Promise<SupervisorTeamHomeworkData>;
  getSupervisorTeamHomeworkDetail(
    clinicianCode: string,
    patientId: string,
    homeworkAssignmentId: string,
    signal?: AbortSignal,
  ): Promise<SupervisorTeamHomeworkDetailData>;
  getSupervisorTeamReports(
    clinicianCode: string,
    clinicId?: string,
    signal?: AbortSignal,
  ): Promise<SupervisorTeamReportsData>;
  getSupervisorTeamAttention(
    clinicianCode: string,
    clinicId?: string,
    signal?: AbortSignal,
  ): Promise<SupervisorTeamAttentionData>;
  getClient(
    clinicianCode: string,
    patientId: string,
    includeHomeworkEngagement: boolean,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<ClientProfilePageData>;
  getRecordFormConfig(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<RecordFormConfigData>;
  getRelationOptions(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<RelationOptionsData>;
  createClient(
    clinicianCode: string,
    fields: CreateClientFields,
    signal?: AbortSignal,
  ): Promise<CreateClientData>;
  updateClient(
    clinicianCode: string,
    patientId: string,
    fields: UpdateClientFields,
    signal?: AbortSignal,
  ): Promise<UpdateClientData>;
  getClientValues(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<ClientValuesData>;
  getValueEngagement(
    clinicianCode: string,
    patientId: string,
    activityTemplateId?: string,
    signal?: AbortSignal,
  ): Promise<ValueEngagementReportData>;
  getHomeworkOverview(
    clinicianCode: string,
    patientId: string,
    period: HomeworkOverviewPeriod,
    startDate?: string,
    endDate?: string,
    signal?: AbortSignal,
  ): Promise<HomeworkOverviewReportData>;
  getCompletionByDevice(
    clinicianCode: string,
    patientId: string,
    activityTemplateId: string,
    period: CompletionByDevicePeriod,
    startDate?: string,
    endDate?: string,
    signal?: AbortSignal,
  ): Promise<CompletionByDeviceReportData>;
  getDashboardAttention(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<DashboardAttentionReportData>;
  createClientValue(
    clinicianCode: string,
    patientId: string,
    valueName: string,
    whyImportant: string,
    signal?: AbortSignal,
  ): Promise<CreateClientValueData>;
  updateClientValue(
    clinicianCode: string,
    patientId: string,
    valueId: string,
    valueName: string,
    whyImportant: string,
    signal?: AbortSignal,
  ): Promise<UpdateClientValueData>;
  setClientValueEnabled(
    clinicianCode: string,
    patientId: string,
    valueId: string,
    enabled: boolean,
    signal?: AbortSignal,
  ): Promise<SetClientValueEnabledData>;
  getRankLevels(
    clinicianCode: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<RankLevelsData>;
  getClientRankLevelRules(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<ClientRankLevelRulesData>;
  createClientRankLevelRule(
    clinicianCode: string,
    patientId: string,
    fields: CreateClientRankLevelRuleFields,
    signal?: AbortSignal,
  ): Promise<CreateClientRankLevelRuleData>;
  updateClientRankLevelRule(
    clinicianCode: string,
    patientId: string,
    ruleId: string,
    fields: UpdateClientRankLevelRuleFields,
    signal?: AbortSignal,
  ): Promise<UpdateClientRankLevelRuleData>;
  setClientRankLevelRuleEnabled(
    clinicianCode: string,
    patientId: string,
    ruleId: string,
    enabled: boolean,
    signal?: AbortSignal,
  ): Promise<SetClientRankLevelRuleEnabledData>;
  getCopingSkills(
    clinicianCode: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<CopingSkillsData>;
  createCopingSkill(
    clinicianCode: string,
    fields: CreateCopingSkillFields,
    signal?: AbortSignal,
  ): Promise<CreateCopingSkillData>;
  updateCopingSkill(
    clinicianCode: string,
    copingSkillId: string,
    fields: UpdateCopingSkillFields,
    signal?: AbortSignal,
  ): Promise<UpdateCopingSkillData>;
  setCopingSkillEnabled(
    clinicianCode: string,
    copingSkillId: string,
    enabled: boolean,
    signal?: AbortSignal,
  ): Promise<SetCopingSkillEnabledData>;
  getClientCopingSkills(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<ClientCopingSkillsData>;
  createClientCopingSkill(
    clinicianCode: string,
    patientId: string,
    fields: CreateCopingSkillFields,
    signal?: AbortSignal,
  ): Promise<CreateClientCopingSkillData>;
  updateClientCopingSkill(
    clinicianCode: string,
    patientId: string,
    copingSkillId: string,
    fields: UpdateCopingSkillFields,
    signal?: AbortSignal,
  ): Promise<UpdateClientCopingSkillData>;
  setClientCopingSkillEnabled(
    clinicianCode: string,
    patientId: string,
    copingSkillId: string,
    enabled: boolean,
    signal?: AbortSignal,
  ): Promise<SetClientCopingSkillEnabledData>;
  getCurrentHomework(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<CurrentHomeworkPageData>;
  getHomeworkHistory(
    clinicianCode: string,
    patientId: string,
    historyFilter: HomeworkHistoryFilter,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<HomeworkHistoryPageData>;
  getClientSessionTranscript(
    clinicianCode: string,
    patientId: string,
    sessionId: string,
    pageSize: number,
    pageOffset: number,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<ClientSessionTranscriptData>;
  getClientSessions(
    clinicianCode: string,
    patientId: string,
    sessionFilter: ClientSessionFilter,
    pageSize: number,
    pageOffset: number,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<ClientSessionsPageData>;
  getHomeworkCalendar(
    clinicianCode: string,
    patientId: string,
    startDate: string,
    endDate: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<HomeworkCalendarPageData>;
  getCaseloadEngagement(
    clinicianCode: string,
    period: CaseloadEngagementPeriod,
    signal?: AbortSignal,
  ): Promise<CaseloadEngagementPageData>;
  getDailyMoodChecks(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<DailyMoodChecksPageData>;
  getYouthTopProblemRatings(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<YouthTopProblemRatingsPageData>;
  getExpectancies(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<ExpectanciesPageData>;
  getHomeworkAnalyses(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<HomeworkAnalysesPageData>;
  generateHomeworkAnalysis(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
  ): Promise<GenerateHomeworkAnalysisData>;
  getActivityTemplates(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<ActivityTemplatesPageData>;
  getActivityRegistry(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<ActivityRegistryPageData>;
  getLovCatalogs(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<LovCatalogsPageData>;
  getLovOptions(
    clinicianCode: string,
    catalogKey: string,
    signal?: AbortSignal,
  ): Promise<LovOptionsPageData>;
  createLovOption(
    clinicianCode: string,
    catalogKey: string,
    fields: CreateLovOptionFields,
    signal?: AbortSignal,
  ): Promise<CreateLovOptionData>;
  updateLovOption(
    clinicianCode: string,
    catalogKey: string,
    optionId: string,
    fields: UpdateLovOptionFields,
    signal?: AbortSignal,
  ): Promise<UpdateLovOptionData>;
  setLovOptionEnabled(
    clinicianCode: string,
    catalogKey: string,
    optionId: string,
    enabled: boolean,
    signal?: AbortSignal,
  ): Promise<SetLovOptionEnabledData>;
  getClinics(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<ClinicsPageData>;
  createClinic(
    clinicianCode: string,
    clinicName: string,
    therapistIds: string[],
    signal?: AbortSignal,
  ): Promise<CreateClinicData>;
  updateClinic(
    clinicianCode: string,
    clinicId: string,
    fields: UpdateClinicFields,
    signal?: AbortSignal,
  ): Promise<UpdateClinicData>;
  createTherapist(
    clinicianCode: string,
    therapistName: string,
    email: string,
    role: AdminTherapistRole,
    clinicIds: string[],
    advancedDashboardEnabled: boolean,
    signal?: AbortSignal,
  ): Promise<CreateTherapistData>;
  updateTherapist(
    clinicianCode: string,
    therapistId: string,
    fields: UpdateTherapistFields,
    signal?: AbortSignal,
  ): Promise<UpdateTherapistData>;
  getTherapists(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<TherapistsPageData>;
  getAllClients(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<AdminClientsPageData>;
  getActivityTemplate(
    clinicianCode: string,
    templateId: string,
    signal?: AbortSignal,
  ): Promise<ActivityTemplateDetailPageData>;
  getActivityTypes(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<ActivityTypesPageData>;
  createActivityTemplate(
    clinicianCode: string,
    fields: ActivityTemplateEditableFields,
    signal?: AbortSignal,
  ): Promise<CreateActivityTemplateData>;
  updateActivityTemplate(
    clinicianCode: string,
    templateId: string,
    fields: ActivityTemplateEditableFields,
    signal?: AbortSignal,
  ): Promise<UpdateActivityTemplateData>;
  updateActivityTemplateSteps(
    clinicianCode: string,
    templateId: string,
    activitySteps: string,
    signal?: AbortSignal,
  ): Promise<UpdateActivityTemplateStepsData>;
  uploadActivityTemplateImage(
    clinicianCode: string,
    templateId: string,
    fields: ActivityTemplateImageUploadFields,
    signal?: AbortSignal,
  ): Promise<UploadActivityTemplateImageData>;
  deleteActivityTemplateImage(
    clinicianCode: string,
    templateId: string,
    imageId: string,
    signal?: AbortSignal,
  ): Promise<DeleteActivityTemplateImageData>;
  getHomeworkActivities(
    clinicianCode: string,
    signal?: AbortSignal,
  ): Promise<HomeworkActivitiesPageData>;
  getHomeworkDetail(
    clinicianCode: string,
    patientId: string,
    homeworkAssignmentId: string,
    signal?: AbortSignal,
    accessScope?: ClientAccessScope,
  ): Promise<HomeworkDetailPageData>;
  createHomework(
    clinicianCode: string,
    patientId: string,
    signal?: AbortSignal,
  ): Promise<CreateHomeworkData>;
  createHomeworkActivity(
    clinicianCode: string,
    patientId: string,
    fields: CreateHomeworkActivityFields,
    signal?: AbortSignal,
  ): Promise<CreateHomeworkActivityData>;
  selectHomeworkTemplate(
    clinicianCode: string,
    patientId: string,
    homeworkAssignmentId: string,
    templateId: string,
    signal?: AbortSignal,
  ): Promise<SelectHomeworkTemplateData>;
  updateHomework(
    clinicianCode: string,
    patientId: string,
    homeworkAssignmentId: string,
    fields: HomeworkUpdateFields,
    signal?: AbortSignal,
  ): Promise<UpdateHomeworkData>;
  uploadHomeworkImage(
    clinicianCode: string,
    patientId: string,
    homeworkAssignmentId: string,
    fields: HomeworkImageUploadFields,
    signal?: AbortSignal,
  ): Promise<UploadHomeworkImageData>;
  deleteHomeworkImage(
    clinicianCode: string,
    patientId: string,
    homeworkAssignmentId: string,
    imageId: string,
    signal?: AbortSignal,
  ): Promise<DeleteHomeworkImageData>;
  updateHomeworkSteps(
    clinicianCode: string,
    patientId: string,
    homeworkAssignmentId: string,
    fields: HomeworkStepsUpdateFields,
    signal?: AbortSignal,
  ): Promise<UpdateHomeworkStepsData>;
  duplicateHomework(
    clinicianCode: string,
    patientId: string,
    homeworkAssignmentId: string,
    signal?: AbortSignal,
  ): Promise<DuplicateHomeworkData>;
  deleteHomework(
    clinicianCode: string,
    patientId: string,
    homeworkAssignmentId: string,
    signal?: AbortSignal,
  ): Promise<DeleteHomeworkData>;
}

function configuredEndpoint(): string | undefined {
  const value = process.env.REACT_APP_CLINICIAN_PORTAL_API_URL;
  return value?.trim() || undefined;
}

function assertRequestValue(value: string, label: string): string {
  const normalized = value.trim();
  if (!normalized) {
    throw new ClinicianPortalApiError(
      `${label} is required.`,
      "INVALID_REQUEST",
      false,
    );
  }
  return normalized;
}

function assertHistoryFilter(
  value: HomeworkHistoryFilter,
): HomeworkHistoryFilter {
  if (!homeworkHistoryFilters.includes(value)) {
    throw new ClinicianPortalApiError(
      "Homework history filter is invalid.",
      "INVALID_REQUEST",
      false,
    );
  }
  return value;
}

function assertCaseloadEngagementPeriod(
  value: CaseloadEngagementPeriod,
): CaseloadEngagementPeriod {
  if (!caseloadEngagementPeriods.includes(value)) {
    throw new ClinicianPortalApiError(
      "Caseload engagement period is invalid.",
      "INVALID_REQUEST",
      false,
    );
  }
  return value;
}

function assertHomeworkOverviewPeriod(
  value: HomeworkOverviewPeriod,
): HomeworkOverviewPeriod {
  if (!homeworkOverviewPeriods.includes(value)) {
    throw new ClinicianPortalApiError(
      "Homework overview period is invalid.",
      "INVALID_REQUEST",
      false,
    );
  }
  return value;
}

function assertCompletionByDevicePeriod(
  value: CompletionByDevicePeriod,
): CompletionByDevicePeriod {
  if (!completionByDevicePeriods.includes(value)) {
    throw new ClinicianPortalApiError(
      "Completion by device period is invalid.",
      "INVALID_REQUEST",
      false,
    );
  }
  return value;
}

function assertCustomDateRange(
  period: HomeworkOverviewPeriod,
  startDate: string,
  endDate: string,
): { startDate: string; endDate: string } {
  if (period !== "custom") return { startDate: "", endDate: "" };
  const isCalendarDate = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value);
  if (
    !isCalendarDate(startDate) ||
    !isCalendarDate(endDate) ||
    startDate > endDate
  ) {
    throw new ClinicianPortalApiError(
      "A valid start and end date are required for a custom report.",
      "INVALID_REQUEST",
      false,
    );
  }
  return { startDate, endDate };
}

function assertCalendarDateRange(
  startDate: string,
  endDate: string,
): { startDate: string; endDate: string } {
  const isCalendarDate = (value: string) => {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return false;
    const date = new Date(
      Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])),
    );
    return date.toISOString().slice(0, 10) === value;
  };
  const normalizedStartDate = startDate.trim();
  const normalizedEndDate = endDate.trim();
  const inclusiveDays =
    (Date.parse(`${normalizedEndDate}T00:00:00.000Z`) -
      Date.parse(`${normalizedStartDate}T00:00:00.000Z`)) /
      86_400_000 +
    1;
  if (
    !isCalendarDate(normalizedStartDate) ||
    !isCalendarDate(normalizedEndDate) ||
    normalizedStartDate > normalizedEndDate ||
    !Number.isFinite(inclusiveDays) ||
    inclusiveDays > 42
  ) {
    throw new ClinicianPortalApiError(
      "Practice Calendar requires a valid date range of no more than 42 days.",
      "INVALID_REQUEST",
      false,
    );
  }
  return { startDate: normalizedStartDate, endDate: normalizedEndDate };
}

function assertOptionalRequestValues(
  values: string[],
  label: string,
): string[] {
  return values.map((value) => assertRequestValue(value, label));
}

function assertRequiredClinicIds(values: string[]): string[] {
  const clinicIds = assertOptionalRequestValues(values, "Clinic ID");
  if (!clinicIds.length) {
    throw new ClinicianPortalApiError(
      "At least one clinic is required.",
      "INVALID_REQUEST",
      false,
    );
  }
  return clinicIds;
}

function assertTherapistRole(value: AdminTherapistRole): AdminTherapistRole {
  if (value !== "therapist" && value !== "supervisor" && value !== "admin") {
    throw new ClinicianPortalApiError(
      "Therapist role is invalid.",
      "INVALID_REQUEST",
      false,
    );
  }
  return value;
}

function assertAdminRecordStatus(value: string): "Active" | "Inactive" {
  const normalized = value.trim().toLocaleLowerCase();
  if (normalized === "active") return "Active";
  if (normalized === "inactive") return "Inactive";
  throw new ClinicianPortalApiError(
    "Status is invalid.",
    "INVALID_REQUEST",
    false,
  );
}

function assertActivityTemplateFields(
  fields: ActivityTemplateEditableFields,
): ActivityTemplateEditableFields {
  if (fields.status !== "On" && fields.status !== "Off") {
    throw new ClinicianPortalApiError(
      "Activity Template status is invalid.",
      "INVALID_REQUEST",
      false,
    );
  }
  if (!Number.isInteger(fields.points) || !Number.isInteger(fields.coins)) {
    throw new ClinicianPortalApiError(
      "Activity Template points and coins must be integers.",
      "INVALID_REQUEST",
      false,
    );
  }

  return {
    name: assertRequestValue(fields.name, "Activity Template name"),
    description: fields.description,
    activityTypeId: assertRequestValue(
      fields.activityTypeId,
      "Activity Type ID",
    ),
    status: fields.status,
    nonExposureHomework: fields.nonExposureHomework,
    activitySteps: fields.activitySteps,
    alternative: fields.alternative,
    coachingPrompts: fields.coachingPrompts,
    points: fields.points,
    coins: fields.coins,
  };
}

function assertHomeworkUpdateFields(
  fields: HomeworkUpdateFields,
): HomeworkUpdateFields {
  const entries = Object.entries(fields);
  if (!entries.length) {
    throw new ClinicianPortalApiError(
      "At least one Homework field is required.",
      "INVALID_REQUEST",
      false,
    );
  }
  if (
    (fields.points !== undefined && !Number.isInteger(fields.points)) ||
    (fields.coins !== undefined && !Number.isInteger(fields.coins))
  ) {
    throw new ClinicianPortalApiError(
      "Homework points and coins must be integers.",
      "INVALID_REQUEST",
      false,
    );
  }
  for (const [label, value] of [
    ["Pre-Exposure SUDS", fields.firstSuds],
    ["Post-Exposure SUDS", fields.secondSuds],
  ] as const) {
    if (
      value !== undefined &&
      value !== null &&
      (!Number.isInteger(value) || value < 0 || value > 10)
    ) {
      throw new ClinicianPortalApiError(
        `${label} must be an integer from 0 through 10.`,
        "INVALID_REQUEST",
        false,
      );
    }
  }
  return { ...fields };
}

function assertCreateHomeworkActivityFields(
  fields: CreateHomeworkActivityFields,
): CreateHomeworkActivityFields {
  if (!Number.isInteger(fields.points) || !Number.isInteger(fields.coins)) {
    throw new ClinicianPortalApiError(
      "Homework points and coins must be integers.",
      "INVALID_REQUEST",
      false,
    );
  }
  if (
    fields.repeats !== "" &&
    fields.repeats !== "Daily" &&
    fields.repeats !== "Weekly"
  ) {
    throw new ClinicianPortalApiError(
      "Homework recurrence is invalid.",
      "INVALID_REQUEST",
      false,
    );
  }

  return {
    ...fields,
    templateId: assertRequestValue(fields.templateId, "Template ID"),
    homeworkName: assertRequestValue(fields.homeworkName, "Homework Activity"),
    activityTypeId: assertRequestValue(
      fields.activityTypeId,
      "Activity Type ID",
    ),
    valueSupportedId: fields.valueSupportedId.trim(),
    repeatOn: [...fields.repeatOn],
  };
}

function assertHomeworkStepsUpdateFields(
  fields: HomeworkStepsUpdateFields,
): HomeworkStepsUpdateFields {
  if (!Object.keys(fields).length) {
    throw new ClinicianPortalApiError(
      "At least one Homework step field is required.",
      "INVALID_REQUEST",
      false,
    );
  }
  return { ...fields };
}

function invalidClientRequest(message: string): never {
  throw new ClinicianPortalApiError(message, "INVALID_REQUEST", false);
}

function assertClientStringArray(value: string[], label: string): string[] {
  if (
    !Array.isArray(value) ||
    value.some((entry) => typeof entry !== "string")
  ) {
    return invalidClientRequest(`${label} must be a list of values.`);
  }
  return [...value];
}

function assertClientInteger(value: number, label: string): number {
  if (!Number.isInteger(value)) {
    return invalidClientRequest(`${label} must be an integer.`);
  }
  return value;
}

function assertClientMutationFields(
  fields: ClientMutationFields,
): ClientMutationFields {
  const normalized: ClientMutationFields = {};
  if (fields.nickname !== undefined) {
    normalized.nickname = assertRequestValue(fields.nickname, "Nickname");
  }
  if (fields.clinicId !== undefined) {
    normalized.clinicId = assertRequestValue(fields.clinicId, "Clinic");
  }
  if (fields.status !== undefined) normalized.status = fields.status;
  if (fields.clinicalSummary !== undefined) {
    normalized.clinicalSummary = fields.clinicalSummary;
  }
  if (fields.highSudsThreshold !== undefined) {
    normalized.highSudsThreshold = assertClientInteger(
      fields.highSudsThreshold,
      "High SUDS threshold",
    );
  }
  if (fields.sudsInputStyle !== undefined) {
    normalized.sudsInputStyle = fields.sudsInputStyle;
  }
  if (fields.selfInitiatedPermitted !== undefined) {
    if (typeof fields.selfInitiatedPermitted !== "boolean") {
      return invalidClientRequest("Self-initiated permission must be boolean.");
    }
    normalized.selfInitiatedPermitted = fields.selfInitiatedPermitted;
  }
  if (fields.copingStrategies !== undefined) {
    normalized.copingStrategies = assertClientStringArray(
      fields.copingStrategies,
      "Coping strategies",
    );
  }
  if (fields.funActivities !== undefined) {
    normalized.funActivities = assertClientStringArray(
      fields.funActivities,
      "Fun activities",
    );
  }
  if (fields.pointsEarned !== undefined) {
    normalized.pointsEarned = assertClientInteger(
      fields.pointsEarned,
      "Points earned",
    );
  }
  if (fields.coins !== undefined) {
    normalized.coins = assertClientInteger(fields.coins, "Coins");
  }
  if (fields.badgeCollection !== undefined) {
    normalized.badgeCollection = assertClientStringArray(
      fields.badgeCollection,
      "Badge collection",
    );
  }
  return normalized;
}

function assertLovSortOrder(value: number): number {
  if (!Number.isInteger(value) || value < 0) {
    throw new ClinicianPortalApiError(
      "List of Values sort order must be a non-negative integer.",
      "INVALID_REQUEST",
      false,
    );
  }
  return value;
}

function assertLovEnabled(value: boolean): boolean {
  if (typeof value !== "boolean") {
    throw new ClinicianPortalApiError(
      "List of Values enabled status is invalid.",
      "INVALID_REQUEST",
      false,
    );
  }
  return value;
}

function assertRequestBoolean(value: boolean, label: string): boolean {
  if (typeof value !== "boolean") {
    throw new ClinicianPortalApiError(
      `${label} is invalid.`,
      "INVALID_REQUEST",
      false,
    );
  }
  return value;
}

function assertRankRuleThreshold(value: number): number {
  if (!Number.isInteger(value) || value < 0) {
    throw new ClinicianPortalApiError(
      "Threshold Points must be a non-negative integer.",
      "INVALID_REQUEST",
      false,
    );
  }
  return value;
}

function assertCreateClientRankLevelRuleFields(
  fields: CreateClientRankLevelRuleFields,
): CreateClientRankLevelRuleFields {
  return {
    rankLevelId: assertRequestValue(fields.rankLevelId, "Rank Level ID"),
    thresholdPoints: assertRankRuleThreshold(fields.thresholdPoints),
  };
}

function assertUpdateClientRankLevelRuleFields(
  fields: UpdateClientRankLevelRuleFields,
): UpdateClientRankLevelRuleFields {
  const normalized: UpdateClientRankLevelRuleFields = {};
  if (fields.rankLevelId !== undefined) {
    normalized.rankLevelId = assertRequestValue(
      fields.rankLevelId,
      "Rank Level ID",
    );
  }
  if (fields.thresholdPoints !== undefined) {
    normalized.thresholdPoints = assertRankRuleThreshold(
      fields.thresholdPoints,
    );
  }
  if (!Object.keys(normalized).length) {
    throw new ClinicianPortalApiError(
      "At least one Rank Level Rule field is required.",
      "INVALID_REQUEST",
      false,
    );
  }
  return normalized;
}

function assertGuideSteps(value: string): string {
  const normalized = value.trim();
  if (!normalized) {
    throw new ClinicianPortalApiError(
      "Guide Steps are required.",
      "INVALID_REQUEST",
      false,
    );
  }
  return normalized;
}

function assertCreateCopingSkillFields(
  fields: CreateCopingSkillFields,
): CreateCopingSkillFields {
  return {
    copingStrategyOptionId: assertRequestValue(
      fields.copingStrategyOptionId,
      "Coping Strategy option ID",
    ),
    guideSteps: assertGuideSteps(fields.guideSteps),
  };
}

function assertUpdateCopingSkillFields(fields: UpdateCopingSkillFields): {
  copingStrategyOptionId?: string;
  guideSteps?: string;
  copingStrategyOptionIdProvided: boolean;
  guideStepsProvided: boolean;
} {
  const normalized: {
    copingStrategyOptionId?: string;
    guideSteps?: string;
    copingStrategyOptionIdProvided: boolean;
    guideStepsProvided: boolean;
  } = {
    copingStrategyOptionIdProvided: fields.copingStrategyOptionId !== undefined,
    guideStepsProvided: fields.guideSteps !== undefined,
  };
  if (fields.copingStrategyOptionId !== undefined) {
    normalized.copingStrategyOptionId = assertRequestValue(
      fields.copingStrategyOptionId,
      "Coping Strategy option ID",
    );
  }
  if (fields.guideSteps !== undefined) {
    normalized.guideSteps = assertGuideSteps(fields.guideSteps);
  }
  if (
    !normalized.copingStrategyOptionIdProvided &&
    !normalized.guideStepsProvided
  ) {
    throw new ClinicianPortalApiError(
      "At least one Coping Skill field is required.",
      "INVALID_REQUEST",
      false,
    );
  }
  return normalized;
}

function assertCreateLovOptionFields(
  catalogKey: string,
  fields: CreateLovOptionFields,
): CreateLovOptionFields {
  const normalized: CreateLovOptionFields = {
    key: assertRequestValue(fields.key, "Option key"),
    name: assertRequestValue(fields.name, "Option name"),
    colorKey: assertRequestValue(fields.colorKey, "Option color"),
    sortOrder: assertLovSortOrder(fields.sortOrder),
    enabled: assertLovEnabled(fields.enabled),
    isDefault: assertLovEnabled(fields.isDefault),
  };

  if (catalogKey !== "activity_types") {
    normalized.value = assertRequestValue(fields.value ?? "", "Option value");
  }

  if (catalogKey === "badges") {
    const collection = fields.collection?.trim();
    const assetPath = fields.assetPath?.trim();
    if (collection) normalized.collection = collection;
    if (assetPath) normalized.assetPath = assetPath;
  }

  return normalized;
}

function assertUpdateLovOptionFields(
  catalogKey: string,
  fields: UpdateLovOptionFields,
): UpdateLovOptionFields {
  const normalized: UpdateLovOptionFields = {};

  if (fields.name !== undefined) {
    normalized.name = assertRequestValue(fields.name, "Option name");
  }
  if (fields.colorKey !== undefined) {
    normalized.colorKey = assertRequestValue(fields.colorKey, "Option color");
  }
  if (fields.sortOrder !== undefined) {
    normalized.sortOrder = assertLovSortOrder(fields.sortOrder);
  }
  if (fields.isDefault !== undefined) {
    normalized.isDefault = assertLovEnabled(fields.isDefault);
  }
  if (catalogKey === "badges") {
    if (fields.collection !== undefined) {
      normalized.collection = fields.collection.trim();
    }
    if (fields.assetPath !== undefined) {
      normalized.assetPath = fields.assetPath.trim();
    }
  }

  if (!Object.keys(normalized).length) {
    throw new ClinicianPortalApiError(
      "At least one editable List of Values field is required.",
      "INVALID_REQUEST",
      false,
    );
  }

  return normalized;
}

export function createClinicianPortalApi(
  options: ClinicianPortalApiOptions = {},
): ClinicianPortalApi {
  const endpoint = options.endpoint?.trim() || configuredEndpoint();
  const fetchImpl = options.fetchImpl;
  const requestCache = options.requestCache ?? new PortalRequestCache();

  async function request<TData, TOperation extends PortalOperation>(
    body: ClinicianPortalApiRequest,
    parse: (value: unknown) => ClinicianPortalApiEnvelope<TData, TOperation>,
    signal?: AbortSignal,
  ): Promise<TData> {
    if (!endpoint) {
      throw new ClinicianPortalApiError(
        "The Clinician Portal API endpoint is not configured.",
        "NOT_CONFIGURED",
        false,
      );
    }

    const executeFetch =
      fetchImpl ??
      (typeof window !== "undefined" && typeof window.fetch === "function"
        ? window.fetch.bind(window)
        : undefined);
    if (!executeFetch) {
      throw new ClinicianPortalApiError(
        "The Clinician Portal API transport is unavailable.",
        "NETWORK_ERROR",
        true,
      );
    }

    requestCache.ensureScope({
      clinicianCode: body.clinicianCode,
      database: body.db,
      edition: "clinician-portal",
    });

    const execute = async (requestSignal: AbortSignal): Promise<TData> => {
      let response: Response;
      try {
        response = await executeFetch(endpoint, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
          signal: requestSignal,
        });
      } catch (error) {
        if (
          error &&
          typeof error === "object" &&
          "name" in error &&
          error.name === "AbortError"
        ) {
          throw error;
        }
        throw new ClinicianPortalApiError(
          "The Clinician Portal API could not be reached.",
          "NETWORK_ERROR",
          true,
        );
      }

      let value: unknown;
      try {
        value = await response.json();
      } catch {
        if (!response.ok) {
          throw new ClinicianPortalApiError(
            "The Clinician Portal API returned an unsuccessful response.",
            "NETWORK_ERROR",
            response.status >= 500,
          );
        }
        throw new ClinicianPortalApiError(
          "The Clinician Portal API returned unreadable JSON.",
          "INVALID_RESPONSE",
          false,
        );
      }

      let envelope: ClinicianPortalApiEnvelope<TData, TOperation>;
      try {
        envelope = parse(value);
      } catch {
        if (!response.ok) {
          throw new ClinicianPortalApiError(
            "The Clinician Portal API returned an unsuccessful response.",
            "NETWORK_ERROR",
            response.status >= 500,
          );
        }
        throw new ClinicianPortalApiError(
          "The Clinician Portal API returned an unexpected response.",
          "INVALID_RESPONSE",
          false,
        );
      }

      if (envelope.error) {
        if (envelope.error.code === "NOT_AUTHORIZED") {
          requestCache.clear();
        }
        throw new ClinicianPortalApiError(
          envelope.error.message,
          envelope.error.code,
          envelope.error.retryable,
        );
      }
      if (!response.ok) {
        throw new ClinicianPortalApiError(
          "The Clinician Portal API returned an unsuccessful response.",
          "NETWORK_ERROR",
          response.status >= 500,
        );
      }
      return envelope.data;
    };

    if (requestCache.isRead(body.operation)) {
      return requestCache.read({ request: body, signal, execute });
    }

    const mutationController = new AbortController();
    const handleAbort = () => mutationController.abort();
    if (signal?.aborted) mutationController.abort();
    else signal?.addEventListener("abort", handleAbort, { once: true });
    try {
      const data = await execute(mutationController.signal);
      requestCache.invalidateAfterMutation(body);
      requestCache.rememberClientSnapshots(data);
      return data;
    } finally {
      signal?.removeEventListener("abort", handleAbort);
    }
  }

  return {
    askClinicianAssistant(clinicianCode, question, context, history, options) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.askClinicianAssistant",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...(options.requestingTherapistId
            ? {
                therapistId: assertRequestValue(
                  options.requestingTherapistId,
                  "Requesting therapist ID",
                ),
              }
            : {}),
          question: assertRequestValue(question, "Question"),
          scope: options.scope,
          context,
          history: history.slice(-10).map((message) => ({
            role: message.role,
            content: assertRequestValue(message.content, "History message"),
          })),
        },
        parseAskClinicianAssistantEnvelope,
        options.signal,
      );
    },
    getMyClients(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getMyClients",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
        },
        parseGetMyClientsEnvelope,
        signal,
      );
    },
    getTablePreferences(clinicianCode, tableKey, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getTablePreferences",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          tableKey,
        },
        parseGetTablePreferencesEnvelope,
        signal,
      );
    },
    saveTablePreferences(
      clinicianCode,
      tableKey,
      columnOrder,
      hiddenColumns,
      columnWidths,
      schemaVersion,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.saveTablePreferences",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          tableKey,
          columnOrder,
          hiddenColumns,
          columnWidths,
          schemaVersion,
        },
        parseSaveTablePreferencesEnvelope,
        signal,
      );
    },
    getSupervisorTeamOverview(clinicianCode, clinicId = "", signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.supervisor.getTeamOverview",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...(clinicId.trim() ? { clinicId: clinicId.trim() } : {}),
        },
        parseGetSupervisorTeamOverviewEnvelope,
        signal,
      );
    },
    getSupervisorTeamClients(clinicianCode, clinicId = "", signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.supervisor.getTeamClients",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...(clinicId.trim() ? { clinicId: clinicId.trim() } : {}),
        },
        parseGetSupervisorTeamClientsEnvelope,
        signal,
      );
    },
    getSupervisorTeamClientDetail(clinicianCode, patientId, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.supervisor.getTeamClientDetail",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
        },
        parseGetSupervisorTeamClientDetailEnvelope,
        signal,
      );
    },
    getSupervisorTeamHomework(clinicianCode, clinicId = "", signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.supervisor.getTeamHomework",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...(clinicId.trim() ? { clinicId: clinicId.trim() } : {}),
        },
        parseGetSupervisorTeamHomeworkEnvelope,
        signal,
      );
    },
    getSupervisorTeamHomeworkDetail(
      clinicianCode,
      patientId,
      homeworkAssignmentId,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.supervisor.getTeamHomeworkDetail",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          homeworkAssignmentId: assertRequestValue(
            homeworkAssignmentId,
            "Homework assignment ID",
          ),
        },
        parseGetSupervisorTeamHomeworkDetailEnvelope,
        signal,
      );
    },
    getSupervisorTeamReports(clinicianCode, clinicId = "", signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.supervisor.getTeamReports",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...(clinicId.trim() ? { clinicId: clinicId.trim() } : {}),
        },
        parseGetSupervisorTeamReportsEnvelope,
        signal,
      );
    },
    getSupervisorTeamAttention(clinicianCode, clinicId = "", signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.supervisor.getTeamAttention",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...(clinicId.trim() ? { clinicId: clinicId.trim() } : {}),
        },
        parseGetSupervisorTeamAttentionEnvelope,
        signal,
      );
    },
    getClient(clinicianCode, patientId, includeHomeworkEngagement, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getClient",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          includeHomeworkEngagement,
          ...(accessScope ? { accessScope } : {}),
        },
        (value) => parseGetClientEnvelope(value, includeHomeworkEngagement),
        signal,
      );
    },
    getRecordFormConfig(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getRecordFormConfig",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          recordType: "client",
        },
        parseGetRecordFormConfigEnvelope,
        signal,
      );
    },
    getRelationOptions(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getRelationOptions",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          recordType: "client",
          fieldKey: "clinicId",
        },
        parseGetRelationOptionsEnvelope,
        signal,
      );
    },
    createClient(clinicianCode, fields, signal) {
      const normalized = assertClientMutationFields(fields);
      if (!normalized.nickname) {
        return invalidClientRequest("Nickname is required.");
      }
      if (!normalized.clinicId) {
        return invalidClientRequest("Clinic is required.");
      }
      return request(
        {
          apiVersion: "1",
          operation: "portal.createClient",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...normalized,
          nickname: normalized.nickname,
          clinicId: normalized.clinicId,
        },
        parseCreateClientEnvelope,
        signal,
      );
    },
    updateClient(clinicianCode, patientId, fields, signal) {
      const normalized = assertClientMutationFields(fields);
      if (!Object.keys(normalized).length) {
        return invalidClientRequest("At least one Client field is required.");
      }
      return request(
        {
          apiVersion: "1",
          operation: "portal.updateClient",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...normalized,
        },
        parseUpdateClientEnvelope,
        signal,
      );
    },
    getClientValues(clinicianCode, patientId, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getClientValues",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetClientValuesEnvelope,
        signal,
      );
    },
    getValueEngagement(clinicianCode, patientId, activityTemplateId, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.reports.getValueEngagement",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          activityTemplateId: activityTemplateId?.trim() || "",
        },
        parseGetValueEngagementEnvelope,
        signal,
      );
    },
    getHomeworkOverview(
      clinicianCode,
      patientId,
      period,
      startDate = "",
      endDate = "",
      signal,
    ) {
      const normalizedPeriod = assertHomeworkOverviewPeriod(period);
      const customDates = assertCustomDateRange(
        normalizedPeriod,
        startDate.trim(),
        endDate.trim(),
      );
      return request(
        {
          apiVersion: "1",
          operation: "portal.reports.getHomeworkOverview",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: patientId.trim(),
          period: normalizedPeriod,
          ...customDates,
        },
        parseGetHomeworkOverviewEnvelope,
        signal,
      );
    },
    getCompletionByDevice(
      clinicianCode,
      patientId,
      activityTemplateId,
      period,
      startDate = "",
      endDate = "",
      signal,
    ) {
      const normalizedPeriod = assertCompletionByDevicePeriod(period);
      const customDates = assertCustomDateRange(
        normalizedPeriod,
        startDate.trim(),
        endDate.trim(),
      );
      return request(
        {
          apiVersion: "1",
          operation: "portal.reports.getCompletionByDevice",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: patientId.trim(),
          activityTemplateId: activityTemplateId.trim(),
          period: normalizedPeriod,
          ...customDates,
        },
        parseGetCompletionByDeviceEnvelope,
        signal,
      );
    },
    getDashboardAttention(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.reports.getDashboardAttention",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
        },
        parseGetDashboardAttentionEnvelope,
        signal,
      );
    },
    createClientValue(
      clinicianCode,
      patientId,
      valueName,
      whyImportant,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.createClientValue",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          valueName: assertRequestValue(valueName, "Value"),
          whyImportant: whyImportant.trim(),
        },
        parseCreateClientValueEnvelope,
        signal,
      );
    },
    updateClientValue(
      clinicianCode,
      patientId,
      valueId,
      valueName,
      whyImportant,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.updateClientValue",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          valueId: assertRequestValue(valueId, "Value ID"),
          valueName: assertRequestValue(valueName, "Value"),
          whyImportant: whyImportant.trim(),
        },
        parseUpdateClientValueEnvelope,
        signal,
      );
    },
    setClientValueEnabled(clinicianCode, patientId, valueId, enabled, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.setClientValueEnabled",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          valueId: assertRequestValue(valueId, "Value ID"),
          enabled: assertRequestBoolean(enabled, "Value enabled status"),
        },
        parseSetClientValueEnabledEnvelope,
        signal,
      );
    },
    getRankLevels(clinicianCode, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getRankLevels",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetRankLevelsEnvelope,
        signal,
      );
    },
    getClientRankLevelRules(clinicianCode, patientId, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getClientRankLevelRules",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetClientRankLevelRulesEnvelope,
        signal,
      );
    },
    createClientRankLevelRule(clinicianCode, patientId, fields, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.createClientRankLevelRule",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...assertCreateClientRankLevelRuleFields(fields),
        },
        parseCreateClientRankLevelRuleEnvelope,
        signal,
      );
    },
    updateClientRankLevelRule(
      clinicianCode,
      patientId,
      ruleId,
      fields,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.updateClientRankLevelRule",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ruleId: assertRequestValue(ruleId, "Rule ID"),
          ...assertUpdateClientRankLevelRuleFields(fields),
        },
        parseUpdateClientRankLevelRuleEnvelope,
        signal,
      );
    },
    setClientRankLevelRuleEnabled(
      clinicianCode,
      patientId,
      ruleId,
      enabled,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.setClientRankLevelRuleEnabled",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ruleId: assertRequestValue(ruleId, "Rule ID"),
          enabled: assertRequestBoolean(enabled, "Rank Rule enabled status"),
        },
        parseSetClientRankLevelRuleEnabledEnvelope,
        signal,
      );
    },
    getCopingSkills(clinicianCode, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getCopingSkills",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetCopingSkillsEnvelope,
        signal,
      );
    },
    createCopingSkill(clinicianCode, fields, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.createCopingSkill",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...assertCreateCopingSkillFields(fields),
        },
        parseCreateCopingSkillEnvelope,
        signal,
      );
    },
    updateCopingSkill(clinicianCode, copingSkillId, fields, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.updateCopingSkill",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          copingSkillId: assertRequestValue(copingSkillId, "Coping Skill ID"),
          ...assertUpdateCopingSkillFields(fields),
        },
        parseUpdateCopingSkillEnvelope,
        signal,
      );
    },
    setCopingSkillEnabled(clinicianCode, copingSkillId, enabled, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.setCopingSkillEnabled",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          copingSkillId: assertRequestValue(copingSkillId, "Coping Skill ID"),
          enabled: assertRequestBoolean(enabled, "Coping Skill enabled status"),
        },
        parseSetCopingSkillEnabledEnvelope,
        signal,
      );
    },
    getClientCopingSkills(clinicianCode, patientId, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getClientCopingSkills",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetClientCopingSkillsEnvelope,
        signal,
      );
    },
    createClientCopingSkill(clinicianCode, patientId, fields, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.createClientCopingSkill",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...assertCreateCopingSkillFields(fields),
        },
        parseCreateClientCopingSkillEnvelope,
        signal,
      );
    },
    updateClientCopingSkill(
      clinicianCode,
      patientId,
      copingSkillId,
      fields,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.updateClientCopingSkill",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          copingSkillId: assertRequestValue(copingSkillId, "Coping Skill ID"),
          ...assertUpdateCopingSkillFields(fields),
        },
        parseUpdateClientCopingSkillEnvelope,
        signal,
      );
    },
    setClientCopingSkillEnabled(
      clinicianCode,
      patientId,
      copingSkillId,
      enabled,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.setClientCopingSkillEnabled",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          copingSkillId: assertRequestValue(copingSkillId, "Coping Skill ID"),
          enabled: assertRequestBoolean(enabled, "Coping Skill enabled status"),
        },
        parseSetClientCopingSkillEnabledEnvelope,
        signal,
      );
    },
    getCurrentHomework(clinicianCode, patientId, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getCurrentHomework",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetCurrentHomeworkEnvelope,
        signal,
      );
    },
    async getClientSessionTranscript(
      clinicianCode,
      patientId,
      sessionId,
      pageSize,
      pageOffset,
      signal,
      accessScope,
    ) {
      const requestedPatient = assertRequestValue(patientId, "Patient ID");
      const requestedSession = assertRequestValue(sessionId, "Session ID");
      if (
        requestedSession.length > 200 ||
        !Number.isSafeInteger(pageSize) ||
        pageSize < 1 ||
        pageSize > 100 ||
        !Number.isSafeInteger(pageOffset) ||
        pageOffset < 0 ||
        pageOffset > 2147483647
      ) {
        throw new ClinicianPortalApiError(
          "Transcript request is invalid.",
          "INVALID_REQUEST",
          false,
        );
      }
      return request(
        {
          apiVersion: "1",
          operation: "portal.getClientSessionTranscript",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: requestedPatient,
          sessionId: requestedSession,
          pageSize,
          pageOffset,
          ...(accessScope ? { accessScope } : {}),
        },
        (value) => {
          const envelope = parseGetClientSessionTranscriptEnvelope(value);
          if (
            envelope.error === null &&
            (envelope.data.patient.id !== requestedPatient ||
              envelope.data.sessionId !== requestedSession ||
              envelope.data.pageSize !== pageSize ||
              envelope.data.pageOffset !== pageOffset)
          ) {
            throw new Error("Transcript response does not match the request.");
          }
          return envelope;
        },
        signal,
      );
    },
    async getClientSessions(
      clinicianCode,
      patientId,
      sessionFilter,
      pageSize,
      pageOffset,
      signal,
      accessScope,
    ) {
      if (
        !clientSessionFilters.includes(sessionFilter) ||
        !Number.isSafeInteger(pageSize) ||
        pageSize < 1 ||
        pageSize > 100 ||
        !Number.isSafeInteger(pageOffset) ||
        pageOffset < 0 ||
        pageOffset > 2147483647
      ) {
        throw new ClinicianPortalApiError(
          "Sessions filter or pagination is invalid.",
          "INVALID_REQUEST",
          false,
        );
      }
      const requestedPatientId = assertRequestValue(patientId, "Patient ID");
      const data = await request(
        {
          apiVersion: "1",
          operation: "portal.getClientSessions",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: requestedPatientId,
          sessionFilter,
          pageSize,
          pageOffset,
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetClientSessionsEnvelope,
        signal,
      );
      if (
        data.patient?.id !== requestedPatientId ||
        data.sessionFilter !== sessionFilter ||
        data.pageSize !== pageSize ||
        data.pageOffset !== pageOffset
      ) {
        throw new ClinicianPortalApiError(
          "Sessions response does not match the request.",
          "INVALID_RESPONSE",
          false,
        );
      }
      return data;
    },
    getHomeworkHistory(clinicianCode, patientId, historyFilter, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getHomeworkHistory",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          historyFilter: assertHistoryFilter(historyFilter),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetHomeworkHistoryEnvelope,
        signal,
      );
    },
    getHomeworkCalendar(clinicianCode, patientId, startDate, endDate, signal, accessScope) {
      const range = assertCalendarDateRange(startDate, endDate);
      return request(
        {
          apiVersion: "1",
          operation: "portal.getHomeworkCalendar",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...range,
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetHomeworkCalendarEnvelope,
        signal,
      );
    },
    getCaseloadEngagement(clinicianCode, period, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getCaseloadEngagement",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          period: assertCaseloadEngagementPeriod(period),
        },
        parseGetCaseloadEngagementEnvelope,
        signal,
      );
    },
    getDailyMoodChecks(clinicianCode, patientId, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getDailyMoodChecks",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetDailyMoodChecksEnvelope,
        signal,
      );
    },
    getYouthTopProblemRatings(clinicianCode, patientId, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getYouthTopProblemRatings",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetYouthTopProblemRatingsEnvelope,
        signal,
      );
    },
    getExpectancies(clinicianCode, patientId, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getExpectancies",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetExpectanciesEnvelope,
        signal,
      );
    },
    getHomeworkAnalyses(clinicianCode, patientId, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getHomeworkAnalyses",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetHomeworkAnalysesEnvelope,
        signal,
      );
    },
    generateHomeworkAnalysis(clinicianCode, patientId, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.generateHomeworkAnalysis",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
        },
        parseGenerateHomeworkAnalysisEnvelope,
        signal,
      );
    },
    getActivityTemplates(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getActivityTemplates",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
        },
        parseGetActivityTemplatesEnvelope,
        signal,
      );
    },
    getActivityRegistry(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.getActivityRegistry",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
        },
        parseGetActivityRegistryEnvelope,
        signal,
      );
    },
    getLovCatalogs(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.getLovCatalogs",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
        },
        parseGetLovCatalogsEnvelope,
        signal,
      );
    },
    getLovOptions(clinicianCode, catalogKey, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.getLovOptions",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          catalogKey: assertRequestValue(catalogKey, "Catalog key"),
        },
        parseGetLovOptionsEnvelope,
        signal,
      );
    },
    createLovOption(clinicianCode, catalogKey, fields, signal) {
      const normalizedCatalogKey = assertRequestValue(
        catalogKey,
        "Catalog key",
      );
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.createLovOption",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          catalogKey: normalizedCatalogKey,
          ...assertCreateLovOptionFields(normalizedCatalogKey, fields),
        },
        parseCreateLovOptionEnvelope,
        signal,
      );
    },
    updateLovOption(clinicianCode, catalogKey, optionId, fields, signal) {
      const normalizedCatalogKey = assertRequestValue(
        catalogKey,
        "Catalog key",
      );
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.updateLovOption",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          catalogKey: normalizedCatalogKey,
          optionId: assertRequestValue(optionId, "Option ID"),
          ...assertUpdateLovOptionFields(normalizedCatalogKey, fields),
        },
        parseUpdateLovOptionEnvelope,
        signal,
      );
    },
    setLovOptionEnabled(clinicianCode, catalogKey, optionId, enabled, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.setLovOptionEnabled",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          catalogKey: assertRequestValue(catalogKey, "Catalog key"),
          optionId: assertRequestValue(optionId, "Option ID"),
          enabled: assertLovEnabled(enabled),
        },
        parseSetLovOptionEnabledEnvelope,
        signal,
      );
    },
    getClinics(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.getClinics",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
        },
        parseGetClinicsEnvelope,
        signal,
      );
    },
    createClinic(clinicianCode, clinicName, therapistIds, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.createClinic",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          clinicName: assertRequestValue(clinicName, "Clinic name"),
          therapistIds: assertOptionalRequestValues(
            therapistIds,
            "Therapist ID",
          ),
        },
        parseCreateClinicEnvelope,
        signal,
      );
    },
    updateClinic(clinicianCode, clinicId, fields, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.updateClinic",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          clinicId: assertRequestValue(clinicId, "Clinic ID"),
          clinicName: assertRequestValue(fields.clinicName, "Clinic name"),
          status: assertAdminRecordStatus(fields.status),
          therapistIds: assertOptionalRequestValues(
            fields.therapistIds,
            "Therapist ID",
          ),
        },
        parseUpdateClinicEnvelope,
        signal,
      );
    },
    getTherapists(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.getTherapists",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
        },
        parseGetTherapistsEnvelope,
        signal,
      );
    },
    getAllClients(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.getAllClients",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
        },
        parseGetAllClientsEnvelope,
        signal,
      );
    },
    createTherapist(
      clinicianCode,
      therapistName,
      email,
      role,
      clinicIds,
      advancedDashboardEnabled,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.createTherapist",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          therapistName: assertRequestValue(therapistName, "Therapist name"),
          email: assertRequestValue(email, "Email"),
          role: assertTherapistRole(role),
          clinicIds: assertRequiredClinicIds(clinicIds),
          advancedDashboardEnabled: assertRequestBoolean(
            advancedDashboardEnabled,
            "Advanced Dashboard setting",
          ),
        },
        parseCreateTherapistEnvelope,
        signal,
      );
    },
    updateTherapist(clinicianCode, therapistId, fields, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.admin.updateTherapist",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          therapistId: assertRequestValue(therapistId, "Therapist ID"),
          therapistName: assertRequestValue(
            fields.therapistName,
            "Therapist name",
          ),
          email: assertRequestValue(fields.email, "Email"),
          role: assertTherapistRole(fields.role),
          status: assertAdminRecordStatus(fields.status),
          clinicIds: assertRequiredClinicIds(fields.clinicIds),
          advancedDashboardEnabled: assertRequestBoolean(
            fields.advancedDashboardEnabled,
            "Advanced Dashboard setting",
          ),
        },
        parseUpdateTherapistEnvelope,
        signal,
      );
    },
    getActivityTemplate(clinicianCode, templateId, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getActivityTemplate",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          templateId: assertRequestValue(templateId, "Template ID"),
        },
        parseGetActivityTemplateEnvelope,
        signal,
      );
    },
    getActivityTypes(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getActivityTypes",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
        },
        parseGetActivityTypesEnvelope,
        signal,
      );
    },
    createActivityTemplate(clinicianCode, fields, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.createActivityTemplate",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          ...assertActivityTemplateFields(fields),
        },
        parseCreateActivityTemplateEnvelope,
        signal,
      );
    },
    updateActivityTemplate(clinicianCode, templateId, fields, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.updateActivityTemplate",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          templateId: assertRequestValue(templateId, "Template ID"),
          ...assertActivityTemplateFields(fields),
        },
        parseUpdateActivityTemplateEnvelope,
        signal,
      );
    },
    updateActivityTemplateSteps(
      clinicianCode,
      templateId,
      activitySteps,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.updateActivityTemplateSteps",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          templateId: assertRequestValue(templateId, "Template ID"),
          activitySteps: assertRequestValue(activitySteps, "Activity Steps"),
        },
        parseUpdateActivityTemplateStepsEnvelope,
        signal,
      );
    },
    uploadActivityTemplateImage(clinicianCode, templateId, fields, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.uploadActivityTemplateImage",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          templateId: assertRequestValue(templateId, "Template ID"),
          filename: assertRequestValue(fields.filename, "Image filename"),
          mimeType: assertRequestValue(fields.mimeType, "Image MIME type"),
          sizeBytes: fields.sizeBytes,
          contentBase64: assertRequestValue(
            fields.contentBase64,
            "Image content",
          ),
        },
        parseUploadActivityTemplateImageEnvelope,
        signal,
      );
    },
    deleteActivityTemplateImage(clinicianCode, templateId, imageId, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.deleteActivityTemplateImage",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          templateId: assertRequestValue(templateId, "Template ID"),
          imageId: assertRequestValue(imageId, "Image ID"),
        },
        parseDeleteActivityTemplateImageEnvelope,
        signal,
      );
    },
    getHomeworkActivities(clinicianCode, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getHomeworkActivities",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
        },
        parseGetHomeworkActivitiesEnvelope,
        signal,
      );
    },
    getHomeworkDetail(clinicianCode, patientId, homeworkAssignmentId, signal, accessScope) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.getHomeworkDetail",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          homeworkAssignmentId: assertRequestValue(
            homeworkAssignmentId,
            "Homework assignment ID",
          ),
          ...(accessScope ? { accessScope } : {}),
        },
        parseGetHomeworkDetailEnvelope,
        signal,
      );
    },
    createHomework(clinicianCode, patientId, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.createHomework",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
        },
        parseCreateHomeworkEnvelope,
        signal,
      );
    },
    createHomeworkActivity(clinicianCode, patientId, fields, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.createHomeworkActivity",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          ...assertCreateHomeworkActivityFields(fields),
        },
        parseCreateHomeworkActivityEnvelope,
        signal,
      );
    },
    selectHomeworkTemplate(
      clinicianCode,
      patientId,
      homeworkAssignmentId,
      templateId,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.selectHomeworkTemplate",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          homeworkAssignmentId: assertRequestValue(
            homeworkAssignmentId,
            "Homework assignment ID",
          ),
          templateId: assertRequestValue(templateId, "Template ID"),
        },
        parseSelectHomeworkTemplateEnvelope,
        signal,
      );
    },
    updateHomework(
      clinicianCode,
      patientId,
      homeworkAssignmentId,
      fields,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.updateHomework",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          homeworkAssignmentId: assertRequestValue(
            homeworkAssignmentId,
            "Homework assignment ID",
          ),
          ...assertHomeworkUpdateFields(fields),
        },
        parseUpdateHomeworkEnvelope,
        signal,
      );
    },
    uploadHomeworkImage(
      clinicianCode,
      patientId,
      homeworkAssignmentId,
      fields,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.uploadHomeworkImage",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          homeworkAssignmentId: assertRequestValue(
            homeworkAssignmentId,
            "Homework assignment ID",
          ),
          filename: assertRequestValue(fields.filename, "Image filename"),
          mimeType: assertRequestValue(fields.mimeType, "Image MIME type"),
          sizeBytes: fields.sizeBytes,
          contentBase64: assertRequestValue(
            fields.contentBase64,
            "Image content",
          ),
        },
        parseUploadHomeworkImageEnvelope,
        signal,
      );
    },
    deleteHomeworkImage(
      clinicianCode,
      patientId,
      homeworkAssignmentId,
      imageId,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.deleteHomeworkImage",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          homeworkAssignmentId: assertRequestValue(
            homeworkAssignmentId,
            "Homework assignment ID",
          ),
          imageId: assertRequestValue(imageId, "Image ID"),
        },
        parseDeleteHomeworkImageEnvelope,
        signal,
      );
    },
    updateHomeworkSteps(
      clinicianCode,
      patientId,
      homeworkAssignmentId,
      fields,
      signal,
    ) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.updateHomeworkSteps",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          homeworkAssignmentId: assertRequestValue(
            homeworkAssignmentId,
            "Homework assignment ID",
          ),
          ...assertHomeworkStepsUpdateFields(fields),
        },
        parseUpdateHomeworkStepsEnvelope,
        signal,
      );
    },
    duplicateHomework(clinicianCode, patientId, homeworkAssignmentId, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.duplicateHomework",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          homeworkAssignmentId: assertRequestValue(
            homeworkAssignmentId,
            "Homework assignment ID",
          ),
        },
        parseDuplicateHomeworkEnvelope,
        signal,
      );
    },
    deleteHomework(clinicianCode, patientId, homeworkAssignmentId, signal) {
      return request(
        {
          apiVersion: "1",
          operation: "portal.deleteHomework",
          db: "supabase",
          clinicianCode: assertRequestValue(clinicianCode, "Clinician code"),
          patientId: assertRequestValue(patientId, "Patient ID"),
          homeworkAssignmentId: assertRequestValue(
            homeworkAssignmentId,
            "Homework assignment ID",
          ),
        },
        parseDeleteHomeworkEnvelope,
        signal,
      );
    },
  };
}

export const clinicianPortalApi = createClinicianPortalApi({
  requestCache: clinicianPortalRequestCache,
});
